import React, { useState } from 'react';

export default function LoginSectionSignInLightReverse1() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Form validation
    if (!form.email || !form.password) {
      setError('Please enter both email and password.');
      setLoading(false);
      return;
    }

    try {
      // FastAPI OAuth2PasswordRequestForm expects "username" and "password"
      const body = new URLSearchParams();
      body.append('username', form.email);
      body.append('password', form.password);

      const apiBase = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000";

      const res = await fetch(`${apiBase}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body.toString(),
      });

      if (res.ok) {
        const data = await res.json();
        // Save token in localStorage
        localStorage.setItem("token", data.access_token);

        // Fetch /me for the role
        const meRes = await fetch(`${apiBase}/me`, {
          headers: {
            "Authorization": `Bearer ${data.access_token}`,
          },
        });

        if (meRes.ok) {
          const user = await meRes.json();
          // Role-based redirect
          if (user.role === "accountant") window.location.href = "/accountantdashboard";
          else if (user.role === "staff") window.location.href = "/staffdashboard";
          else if (user.role === "admin") window.location.href = "/admindashboard";
          else window.location.href = "/";
        } else {
          setError("Failed to fetch user info. Please try again.");
        }
      } else {
        const err = await res.json();
        setError(err.detail || "Login failed. Please try again.");
      }
    } catch (e) {
      setError("Network error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <section className="py-10 bg-gray-50 overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="pt-16 pb-24 md:pb-52 md:max-w-3xl mx-auto bg-white rounded-3xl">
            <img className="mb-24 mx-auto h-48" src="https://static.shuffle.dev/uploads/files/bd/bd9a85b8a4fa1ba404318e6dc3a1410c26c46d6a/FullLogo.png" alt="" />
            <div className="md:max-w-md mx-auto">
              <div className="mb-10 text-center">
                <h2 className="font-heading mb-4 text-4xl md:text-5xl text-black font-black tracking-tight">Welcome Back</h2>
                <p className="text-gray-500 font-bold">Sign into your account</p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="flex flex-wrap -m-3">
                  {error && (
                    <div className="w-full p-3">
                      <div className="bg-red-100 text-red-700 px-4 py-2 rounded font-bold">{error}</div>
                    </div>
                  )}
                  <div className="w-full p-3">
                    <label className="block mb-2 text-sm text-gray-500 font-bold" htmlFor="signInLightReverseInput3-1">Email Address</label>
                    <input
                      className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-gray-100 placeholder-gray-500 outline-none border border-gray-200 focus:ring-4 focus:ring-blue-200 rounded-full"
                      id="signInLightReverseInput3-1"
                      type="email"
                      name="email"
                      placeholder="Enter email address"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="w-full p-3">
                    <label className="block mb-2 text-sm text-gray-500 font-bold" htmlFor="signInLightReverseInput3-2">Password</label>
                    <div className="border border-gray-200 overflow-hidden rounded-full focus-within:ring-4 focus-within:ring-blue-200">
                      <div className="flex flex-wrap">
                        <div className="flex-1">
                          <input
                            className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-gray-100 placeholder-gray-500 outline-none"
                            id="signInLightReverseInput3-2"
                            type="password"
                            name="password"
                            placeholder="*************"
                            value={form.password}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="w-auto">
                          {/* Add real forgot password logic here if needed */}
                          <a className="flex items-center pr-4 text-blue-500 hover:text-blue-600 h-full bg-gray-100 font-bold" href="#">Forgot password?</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full p-3">
                    <div className="flex flex-wrap md:justify-end -m-2">
                      <div className="w-full p-2">
                        <button
                          className="block w-full px-8 py-3.5 text-lg text-center text-white font-bold bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 rounded-full"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Signing in..." : "Sign In"}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="w-full p-3">
                    <p className="text-gray-600 text-center font-bold">
                      <span>Don’t have an account? </span>
                      <a className="text-blue-500 hover:text-blue-600 font-bold" href="/register">
                        Create one here!
                      </a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
